'use client';

import SearchBar from 'components/controls/search-bar';
import { useState } from 'react';

const LIBRARY_SEARCH_BASE =
	'https://library.metmuseum.org/search/?searchtype=X&SORT=D&searchscope=1';

const LibrarySearchWrapper = () => {
	const [query, setQuery] = useState('');
	const [isSearching, setIsSearching] = useState(false);

	const handleSearch = () => {
		if (!query) return;
		setIsSearching(true);
		const url = `${LIBRARY_SEARCH_BASE}&searcharg=${encodeURIComponent(query)}`;
		window.open(url, '_blank');
	};

	return (
		<SearchBar
			debounceTimeout={0}
			placeholderText="Search the catalog"
			onChange={(event) => setQuery(event.target.value)}
			onKeyDown={(event) => event.key === 'Enter' && handleSearch()}
			onButtonClick={handleSearch}
			isSearching={isSearching}
		/>
	);
};

export default LibrarySearchWrapper;
